import { render } from "./loginGoogle.html?vue&type=template&id=5d60d18a"
import script from "./LoginGoogle.vue?vue&type=script&lang=ts"
export * from "./LoginGoogle.vue?vue&type=script&lang=ts"
script.render = render

export default script